var map = {
	"./black/index.js": [
		"962e",
		"chunk-b50b948e"
	],
	"./blue/index.js": [
		"7612",
		"chunk-4db3c2dc"
	],
	"./golden/index.js": [
		"f5d4",
		"chunk-7b5a7c92"
	],
	"./green/index.js": [
		"23be",
		"chunk-8a1f7b42"
	],
	"./red/index.js": [
		"9529",
		"chunk-7889aa92"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ab12";
module.exports = webpackAsyncContext;